var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeveloperApi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 4.33073C1.66602 3.39731 1.66602 2.9306 1.84767 2.57408C2.00746 2.26047 2.26243 2.00551 2.57603 1.84572C2.93255 1.66406 3.39926 1.66406 4.33268 1.66406H10.666C11.5994 1.66406 12.0661 1.66406 12.4227 1.84572C12.7363 2.00551 12.9912 2.26047 13.151 2.57408C13.3327 2.9306 13.3327 3.39731 13.3327 4.33073V10.6641C13.3327 11.5975 13.3327 12.0642 13.151 12.4207C12.9912 12.7343 12.7363 12.9893 12.4227 13.1491C12.0661 13.3307 11.5994 13.3307 10.666 13.3307H4.33268C3.39926 13.3307 2.93255 13.3307 2.57603 13.1491C2.26243 12.9893 2.00746 12.7343 1.84767 12.4207C1.66602 12.0642 1.66602 11.5975 1.66602 10.6641V4.33073Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 9.33073C6.66602 8.39731 6.66602 7.9306 6.84767 7.57408C7.00746 7.26048 7.26243 7.00551 7.57603 6.84572C7.93255 6.66406 8.39926 6.66406 9.33268 6.66406H15.666C16.5994 6.66406 17.0661 6.66406 17.4227 6.84572C17.7363 7.00551 17.9912 7.26048 18.151 7.57408C18.3327 7.9306 18.3327 8.39731 18.3327 9.33073V15.6641C18.3327 16.5975 18.3327 17.0642 18.151 17.4207C17.9912 17.7343 17.7363 17.9893 17.4227 18.1491C17.0661 18.3307 16.5994 18.3307 15.666 18.3307H9.33268C8.39926 18.3307 7.93255 18.3307 7.57603 18.1491C7.26243 17.9893 7.00746 17.7343 6.84767 17.4207C6.66602 17.0642 6.66602 16.5975 6.66602 15.6641V9.33073Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloperApi);
export default __webpack_public_path__ + "static/media/developer-api.962a2460609348aad85d9ab40cf42b48.svg";
export { ForwardRef as ReactComponent };